import * as React from 'react';
import { Button } from '@cian/ui-kit';
import { IconActionShareAndroid16 } from '@cian/ui-kit-design-tokens/icons';

interface IShareButtonProps {
  onClick(): void;
  ref?: React.Ref<HTMLButtonElement>;
}

export function ShareButton({ onClick, ref }: IShareButtonProps): React.JSX.Element {
  return (
    <Button
      data-testid={'ShareButton'}
      theme={'fill_secondary'}
      size={'XS'}
      onClick={onClick}
      ref={ref}
      beforeIcon={<IconActionShareAndroid16 color={'icon-main-default'} />}
    ></Button>
  );
}
